import React, { createContext, useState, useEffect } from "react";

export const MemoryTimerContext = createContext();

const MemoryTimerContextProvider = (props) => {

    const [time, setTime] = useState(0);
    const [timerOn, setTimerOn] = useState(false);

    const handleTimer = (turnOn) => {
        if(turnOn){
            setTimerOn(turnOn);
        } else{
            setTimerOn(false);
        }
    };

    const resetTime = () => {
        setTime(0);
    };

    return(
        <MemoryTimerContext.Provider 
            value={{
                time, 
                setTime, 
                timerOn, 
                handleTimer, 
                resetTime}}
        >{props.children}</MemoryTimerContext.Provider>
    );
};

export default MemoryTimerContextProvider;